module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "zk-message-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "zk-message",
    on: {
      "mouseenter": _vm.clearTimer,
      "mouseleave": _vm.startTimer
    }
  }, [_c('img', {
    staticClass: "zk-message__icon",
    attrs: {
      "src": _vm.typeImg,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "zk-message__group"
  }, [_c('p', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), (_vm.showClose) ? _c('div', {
    staticClass: "zk-message__closeBtn zk-icon-close",
    on: {
      "click": _vm.handleClose
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-acdcfa4e"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/message/src/message.vue
// module id = 279
// module chunks = 0